export default __webpack_public_path__ + "static/media/filter_icon_playground_blue.a1031847.svg";